module.exports = __webpack_public_path__ + "img/index_lou_icon_7.289675b6.png";